import { SwitchSeeker } from 'ui-seeker/core'
import * as React from 'react'
import { useContextSelector } from 'use-context-selector'
import { AppCalendarContext } from '../Providers'


export default function AppCalendarPriceByNight() {
    const priceByNight = useContextSelector(AppCalendarContext, ({ state }) => state.priceByNight)
    const updateCalendar = useContextSelector(AppCalendarContext, ({ updateState }) => updateState)

    return <div className="switch-price-night">
        Prices total <SwitchSeeker checked={priceByNight} onChange={() => updateCalendar({ priceByNight: !priceByNight })} /> Prices by night
    </div>
}